import Hero from '@/components/Hero';
import DailzyECommercePlatform from '@/components/Features';
import OrderingMadeSimple from '@/components/OrderingMadeSimple';
import Testimonials from '@/components/Testimonials';
import WhyDailzy from '@/components/WhyDailzy';
import ProductIcons from '@/components/ProductIcons';
import DataAnalytics from '@/components/DataAnalytics';
import HomepageDownload from '@/components/HomepageDownload';
import SEO from '@/components/SEO';
import AdvancedSEO from '@/components/AdvancedSEO';

const Index = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://dailzy.com/#organization",
        "name": "Dailzy",
        "url": "https://dailzy.com",
        "sameAs": [
          "https://www.facebook.com/dailzy",
          "https://www.instagram.com/dailzy",
          "https://www.linkedin.com/company/dailzy",
          "https://twitter.com/dailzy"
        ],
        "logo": {
          "@type": "ImageObject",
          "url": "https://dailzy.com/lovable-uploads/8936458b-f120-42aa-a567-eac1e09a8296.png"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+91-XXXXXXXXXX",
          "contactType": "customer service"
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://dailzy.com/#website", 
        "url": "https://dailzy.com",
        "name": "Dailzy",
        "publisher": {
          "@id": "https://dailzy.com/#organization"
        },
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://dailzy.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "Service",
        "name": "Quick Commerce Delivery",
        "provider": {
          "@id": "https://dailzy.com/#organization"
        },
        "serviceType": "Delivery Service",
        "description": "10-20 minute delivery of groceries, electronics, medicines & luxury goods",
        "areaServed": {
          "@type": "Country",
          "name": "India"
        },
        "availabilityStarts": "06:00",
        "availabilityEnds": "23:59",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
      }
    ]
  };

  return (
    <div className="min-h-screen w-full overflow-x-hidden">
      <SEO
        title="Dailzy - Quick Commerce for Daily & Luxury Goods | 10-Min Instant Delivery India"
        description="India's affordable quick commerce platform delivering groceries, electronics, medicines & luxury goods in 10-20 minutes. Order now from local vendors with best prices & quality assured products."
        keywords="quick commerce, instant delivery, groceries online, 10 minute delivery, daily essentials, luxury goods, local vendors, online shopping India, fast delivery app, hyperlocal delivery"
        url="https://dailzy.com/"
        type="website"
        structuredData={structuredData}
      />
      
      <AdvancedSEO 
        page="home"
        additionalKeywords={['quick delivery India', 'instant grocery', 'hyperlocal commerce', 'local vendors', '10 minute delivery']}
        enableWebVitals={true}
        enableHeatmap={false}
      />
      
      <main className="w-full overflow-x-hidden">
        <section id="hero" aria-label="Hero Section">
          <Hero />
        </section>
        
        <section id="features" aria-label="Features Section">
          <h2 className="sr-only">Features</h2>
          <DailzyECommercePlatform />
        </section>
        <ProductIcons />
        <OrderingMadeSimple />
        <WhyDailzy />
        <DataAnalytics />
        <Testimonials />
        <HomepageDownload />
        
      </main>
    </div>
  );
};

export default Index;
